import Paging from './paging';
import SearchInput from './searchInput';
import { slugifyUrl } from '../helpers/slugifyUrl';
import JmtoIcon from 'static/img/logogram.svg';
import _ from 'lodash';

export default ({ ...props }) => {
	const data = {
		subtitle: 'Berita',
		title: 'Lebih dekat dengan JMTO',
		wording: 'Kumpulan berita terbaru dari JMTO',
		link: '/berita',
		list: props.feed.data,
		unSearch: props.unSearch
	};
	

	return (
		<div className="py-4_custom">
			<div className="container">
				<div className="head text-center pb-4">
					<div>
						<h6 className="text-secondary text-uppercase">{data.subtitle}</h6>
					</div>
					<div className="my-3">
						<h2 className="text-primary text-uppercase font-weight-bold">{data.title}</h2>
					</div>
					<div>
						<h6 className="text-primary">{data.wording}</h6>
					</div>

					{data.unSearch ? (
						''
					) : (
						<div>
							<SearchInput param={props.param}  />
						</div>
					)}
				</div>
				<div className="main my-4 py-2">
					<div className="row">
						{data.list.map((item, key) => (
							<div key={key} className="col-md-12 col-lg-4 mb-4">
								<div className="cell-grid border border-softgray h-100 position-relative">
									<div className="img-grid" style={{ backgroundImage: `url('${process.env.NEXT_PUBLIC_BASE_IMG+item.imgCover}')` }} />
									<div className="text-center icon-cover">
										<img src={JmtoIcon} />
									</div>
									<div className="text-center mt-4">
										<span className="text-primary font-weight-bold">{item.publishAt}</span>
									</div>
									<div className="text-center p-3">
										<h6 className="text-primary text-uppercase line-height_custom">{item.title}</h6>
									</div>
									<div className="position-absolute w-100 h-100 bg-primary_transparent p-4 collapse animated slideInUp">
										<p className="text-white pt-4 mt-4 mb-4">
											{_.truncate(item.body, { length: 250, separator: /,?\.* +/ })}
										</p>

										<a
											href={'/berita/' + item.id + '/' + slugifyUrl(item.title)}
											className="btn btn-sm btn-outline-light"
										>
											Read More <i className="arrow right" />
										</a>
									</div>
								</div>
							</div>
						))}
					</div>
				</div>
				<div className="foot text-center">
					{props.usePage ? (
						<Paging last_page={props.feed.meta.last_page} {...props} />
					) : (
						<a href={data.link} className="btn btn-outline-primary">
							Load More <i className="arrow right" />
						</a>
					)}
				</div>
			</div>
			<style jsx>
				{`
					@import './styles/jmto-custom';
					.text-secondary {
						letter-spacing: 2px;
					}
					.py-4_custom {
						padding-top: 6em;
						padding-bottom: 4em;
					}
					.img-grid {
						padding-bottom: 70%;
						background-position: center center;
						background-size: cover;
					}
					.icon-cover {
						margin-top: -42px;
					}
					.line-height_custom {
						line-height: 1.5em;
					}
					.bg-primary_transparent {
						background-color: rgba($blue, 0.9);
						top: 0;
					}
					.cell-grid {
						overflow: hidden;
					}
					.cell-grid .bg-primary_transparent {
						animation-duration: .5s;
					}
					.cell-grid:hover {
						box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.16);
					}
					.cell-grid:hover .bg-primary_transparent {
						display: block;
					}
					@media (max-width: 767.98px) {
						.col-sm{
							padding:0;
						}
						.head{
							padding-bottom:.5em !important;
						}
					}
				`}
			</style>
		</div>
	);
};
